import { useSelector } from 'react-redux';
import { CostAndFeesWrapper, DisclaimerText, LinkContainer } from './HdpSummaryCostsAndFees.styles';
import Linker from 'app/shared/modules/Linker';
import { useModal } from 'app/shared/contexts/ModalContext';
import type { RootReduxState } from 'app/shared/flux/reducers';
import type { ListingDetails } from 'app/types/listingDetails.type';
import { emitTrackCostsAndFeesModalOpenEvent } from 'app/shared/models/Clickstream/HdpClickstreamEvents';
import { shouldShowTotalMonthlyPriceBadge } from 'app/shared/utils/totalMonthlyPriceUtils';

const hideCostsAndFees = (currentListing: ListingDetails) => {
  if (!currentListing) return false;

  const { active } = currentListing;

  // Hide module for off-market listings
  if (!active) return true;

  return false;
};

export default function HdpSummaryCostsAndFees() {
  const currentListing =
    (useSelector((state: RootReduxState) => state?.currentListingDetails?.currentListing) as ListingDetails) || {};
  const { openModal } = useModal();

  const shouldHide = hideCostsAndFees(currentListing);

  if (shouldHide) return null;

  const handleClick = () => {
    emitTrackCostsAndFeesModalOpenEvent();
    openModal({
      type: 'costsAndFees',
      props: {
        isWebview: false,
      },
    });
  };

  // Hide disclaimer when Total Monthly Price features are active (MA + feature flag)
  // because MA listings now include fees in the total price
  const shouldShowDisclaimer = !shouldShowTotalMonthlyPriceBadge(currentListing);

  return (
    <CostAndFeesWrapper>
      {shouldShowDisclaimer && <DisclaimerText>Doesn&apos;t include required deposits and fees</DisclaimerText>}
      <LinkContainer>
        <Linker onClick={handleClick}>Costs &amp; fees breakdown</Linker>
      </LinkContainer>
    </CostAndFeesWrapper>
  );
}
